import snow from './images/snow.png';
import waves from './images/waves.png';
import blur from './images/blur.png';
import diagonal from './images/diagonal.png';
import square from './images/square.png';
import bubbles from './images/bubbles.png';
import smoke from './images/smoke.png';

import Snow from './bg-styles-components/Snow/Snow';
import Waves from './bg-styles-components/Waves/Waves';
import Blur from './bg-styles-components/Blur/Blur';
import Diagonal from './bg-styles-components/Diagonal/Diagonal';
import Square from './bg-styles-components/Square/Square';
import Smoke from './bg-styles-components/Smoke/Smoke';
import Bubbles from './bg-styles-components/Bubbles/Bubbles';

export const generatorColor = (color) => {
  //~ convert color HEX to rgb
  if (color.substring(0, 1) == '#') {
    color = color.substring(1);
  }

  let rgbColor = {};

  /* Grab each pair (channel) of hex values and parse them to ints using hexadecimal decoding */
  rgbColor.r = parseInt(color.substring(0, 2), 16);
  rgbColor.g = parseInt(color.substring(2, 4), 16);
  rgbColor.b = parseInt(color.substring(4), 16);

  let color1 = getSubColors(rgbColor);
  let color2 = getSubColors(color1);
  let colorsArr = [rgbColor, color1, color2];

  return colorsArr.map(generateRgbString);
};

const generateRgbString = (rgbColor) => {
  return `rgb(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b})`;
};

const getSubColors = (rgbColor) => {
  let subColor = {};
  subColor.r = Math.round(rgbColor.r * 0.618);
  subColor.g = Math.round(rgbColor.g * 0.618);
  subColor.b = Math.round(rgbColor.b * 0.618);
  return subColor;
};

export const animatedBg = [
  {
    bgName: 'Snow',
    pro: false,
    prevIcon: snow,
    bgComponent: Snow,
  },
  {
    bgName: 'Waves',
    pro: true,
    prevIcon: waves,
    bgComponent: Waves,
  },
  {
    bgName: 'Blur',
    pro: true,
    prevIcon: blur,
    bgComponent: Blur,
  },
  {
    bgName: 'Diagonal',
    pro: true,
    prevIcon: diagonal,
    bgComponent: Diagonal,
  },
  {
    bgName: 'Square',
    pro: true,
    prevIcon: square,
    bgComponent: Square,
  },
  {
    bgName: 'Bubbles',
    pro: true,
    prevIcon: bubbles,
    bgComponent: Bubbles,
  },
  {
    bgName: 'Smoke',
    pro: true,
    prevIcon: smoke,
    bgComponent: Smoke,
  },
];
